module.exports = __webpack_public_path__ + "img/grx_ankusoni343.ea58b27.png";